export const accountActions = {
  SET_ACCOUNT: 'setAccount',
  SET_DOB: 'setDob',
};

export const setDob = (dob) => ({
  type: accountActions.SET_DOB,
  payload: dob,
});

export const setAccount = (account) => ({
  type: accountActions.SET_ACCOUNT,
  payload: account,
});
